<template>
    <div>
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
                <div class="row">
                  <div class="col-md-4">
                    <h5 class="title">{{ $t( "vehicleRequests.vehicleRequests") }}</h5>
                  </div>
                  <div class="col-md-4">
                  <div class="text-center spinner-container" v-if="!requests.loaded">
                    <div class="spinner-border" role="status">
                      <span class="sr-only">{{ $t( "general.loading") }}</span>
                    </div>
                  </div>
                  </div>
                  <div class="col-md-4 action-buttons-col">
                    <p-button class="refresh-btn" type="info" @click="refreshData()">
                       <i class="fa fa-sync-alt"></i>
                    </p-button>
                  </div>
                </div>
            </div>

            <div class="table-responsive table-full-width" v-if="user && user.data && requests.loaded">
              <el-table
                v-if="requests.loaded"
                :default-sort = "{prop: 'value', order: 'ascending'}"
                class="table-expandable"
                :data="requests.data.cases"
                @row-click="rowClicked"
                ref="tableFleet"
                style="width: 100%">
                <el-table-column type="expand" align="right">
                  <template slot-scope="props">
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="row">
                          <div class="col-sm-6">
                            <card style="">
                                <h4 class="card-title"><i class="fa fa-comment-dots"></i>{{ $t( "vehicleRequests.request") }}</h4>
                                <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.requestId") }}</h6>
                                <p class="card-text">{{props.row.dcsId}}</p>
                                <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.neededByDate") }}</h6>
                                <p class="card-text">{{ formatDateTime(props.row.metadata.car_request_needed_by_date) }}</p>
                                <h6 class="card-subtitle mb-2 text-muted">{{ $t( "contacts.note") }}</h6>
                                <p class="card-text">{{props.row.metadata.car_request_note || '-'}}</p>
                            </card>
                          </div>
                          <div class="col-sm-6">
                            <card style="">
                                <h4 class="card-title"><i class="fa fa-info"></i> {{ $t( "vehicleRequests.additionalInfo") }}</h4>
                                <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.deliveryEta") }}</h6>
                                <p class="card-text">{{ props.row.metadata.car_request_eta_date || '-' }}</p>
                                <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.prerunVehicleAvailableOn") }}</h6>
                                <p class="card-text">{{ formatDateTime(props.row.metadata.car_request_prerun_date) }}</p>
                                <div v-if="props.row.metadata.reviewApprovedOn">
                                  <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.approvedOn") }}</h6>
                                  <p class="card-text">{{ formatDateTime(props.row.metadata.reviewApprovedOn) }}</p>
                                  <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.approvedBy") }}</h6>
                                  <p class="card-text">{{props.row.metadata.reviewApprovedBy || '-'}}</p>
                                </div>
                                <div v-if="props.row.metadata.reviewRejectedOn">
                                  <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.rejectedOn") }} </h6>
                                  <p class="card-text">{{ formatDateTime(props.row.metadata.reviewRejectedOn) }}</p>
                                  <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.rejectedBy") }}</h6>
                                  <p class="card-text">{{props.row.metadata.reviewRejectedBy || '-'}}</p>
                                </div>
                            </card>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-6">
                            <card style="">
                                <h4 class="card-title"><i class="fa fa-car-side"></i>{{ $t( "vehicleRequests.currentVehicle") }}</h4>
                                <h6 class="card-subtitle mb-2 text-muted">{{ $t( "myFleet.model") }}</h6>
                                <p class="card-text">{{props.row.metadata.currentMobileAppVehicle || '-' }}</p>
                                <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.duration") }}</h6>
                                <p class="card-text">{{props.row.metadata.currentMobileAppVehicleMj || '-' }}</p>
                                <h6 class="card-subtitle mb-2 text-muted">{{ $t( "vehicleRequests.mileageTotal") }}</h6>
                                <p class="card-text">{{ formatMileage(props.row.metadata.currentMobileAppVehicleKm) }}</p>
                            </card>
                          </div>
                        </div>
                      </div>
                      <div class="col-sm-6 vehicle-request-tickets">
                        <h4 class="card-title text-center"><i class="fa fa-comments"></i>{{ $t( "vehicleRequests.messages") }}</h4>
                        <div v-for="(msg, i) in props.row.activities" :key="i">
                          <div class="msg-container row" :class="msg.createdFromPortal ? 'from-portal' : 'from-flota'">
                            <div class="speech-bubble">
                              <div class="activity-name">{{ formatActivityAuthor(msg) }}</div>
                              <div class="activity-text">{{msg.description}}</div>
                              <div class="activity-datetime">{{formatDateChat(msg.created) + ' ' + formatTime(msg.created)}}</div>
                            </div>
                          </div>
                        </div>
                        <div class="row activity-input-container">
                            <fg-input class="activity-input"
                                      :placeholder='$t( "contacts.typeMessage")'
                                      addon-left-icon="fa fa-pencil"
                                      v-model="newActivityText"
                                      v-on:keyup.enter="sendNewActivity(props.row._id)">
                            </fg-input>
                            <p-button class="send-activity-btn" size="sm" type="success" :disabled="newActivitySendInProgress || !newActivityText" @click="sendNewActivity(props.row._id)"><i class="nc-icon nc-send"></i></p-button>
                            <div class="spinner-container-activity" v-if="newActivitySendInProgress">
                              <div class="spinner-border" role="status">
                                <span class="sr-only">{{ $t( "general.loading") }}</span>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "vehicleRequests.requestedBy")'
                  prop="metadata.contactName">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "vehicleRequests.requestedDate")'
                  :formatter="(r, c, val, i) => formatDate(val)"
                  prop="created">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "vehicleRequests.model")'
                  prop="metadata.car_request_model">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "vehicleRequests.mileagePerYear")'
                  align="right"
                  :formatter="(r, c, val, i) => formatMileage(val)"
                  prop="metadata.car_request_mileage">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "vehicleRequests.duration")'
                  prop="metadata.car_request_duration">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "vehicleRequests.color")'
                  prop="metadata.car_request_color">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "vehicleRequests.neededByDate")'
                  :formatter="(r, c, val, i) => formatDate(val)"
                  prop="metadata.car_request_needed_by_date">
                </el-table-column>
                <el-table-column
                  sortable
                  :label='$t( "vehicleRequests.status")'
                  prop="metadata.reviewStatus"
                  align="center"
                  class="status-column">>
                  <template slot-scope="scope">
                    <i :class="statuses[scope.row.metadata.reviewStatus].icon"></i>
                  </template>
                </el-table-column>
                <el-table-column :label='$t( "vehicleRequests.action")' align="center">
                  <template slot-scope="scope" v-if="scope.row.metadata.reviewStatus === 'pending'">
                    <p-button class="action-button" type="danger" size="sm" icon :title='$t("general.reject")' @click="reject(scope.$index, scope.row)">
                      <i class="fa fa-times-circle"></i>
                    </p-button>
                    <p-button class="action-button" type="success" size="sm" icon :title='$t("general.approve")' @click="approve(scope.$index, scope.row)">
                      <i class="fa fa-check-circle"></i>
                    </p-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>

  import Vue from 'vue'
  import moment from 'moment'

  import swal from 'sweetalert2'

  import {Table, TableColumn, Input} from 'element-ui'
  import {Button, Card} from 'src/components/UIComponents'
  import alerts from 'src/util/alerts.js'


  Vue.use(Table)
  Vue.use(TableColumn)
  Vue.use(Input)
  Vue.use(Button)

  export default {
    components: {
      [Button.name]: Button,
      Card
    },
    data () {
      return {
        newActivityText: '',
        newActivitySendInProgress: false,
        search: '',
        statuses: {
          pending: {
            icon: 'fa fa-exclamation-circle status-icon info'
          },
          approved: {
            icon: 'fa fa-check-circle status-icon success'
          },
          rejected: {
            icon: 'fa fa-times-circle status-icon danger'
          },
        }
      }
    },
    mounted() {
      if (!this.$store.requests.store.requests.loaded) this.$store.requests.actions.getRequests();

    },
    computed: {
      requests: function() { return this.$store.requests.store.requests },
      user: function() { return this.$store.user }
    },
    methods: {
      refreshData() {
        this.$store.requests.actions.getRequests();
      },
      formatDate(date) {
        if (!date) return '-';
        return moment(date).format('DD.MM.YYYY');
      },
      formatTime(date) {
        if (!date) return '-';
        date = moment(date);
        return `${date.format('HH:mm')}`
      },
      formatMileage(mileage) {
        if (!mileage || mileage === 'null' || mileage === '-') return '-';
        mileage = Math.round(mileage);
        mileage = mileage.toString();
        if (mileage !== '' || mileage !== undefined || mileage !== 0  || mileage !== '0' || mileage !== null) {
          return mileage.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        }
        return mileage
      },
      formatDateTime(date) {
        if (!date) return '-';
        return `${this.formatDate(date)} ${this.formatTime(date)}`
      },
      getMomentLocale() {
        return this.$i18n.locale === 'si' ? 'sl' : this.$i18n.locale
      },
      formatActivityAuthor(msg) {
        if (msg.createdFromPortal) return msg.portalUserName
        if (msg.userName) return this.$t('general.autoflotaUserPrefix', { user: msg.userName })
        return msg.contactName
      },
      formatDateChat(date) {
        if (!date) return '-';
        date = moment(date).locale(this.getMomentLocale());
        if (date.isSame(moment(), 'day')) return `${this.$t('general.today')},`
        return `${date.format('ddd').replace('.', '')}, ${date.format('DD.MM.YY')}`
      },
      approve(i, row) {
        let that = this;
          swal({
            title: this.$t('general.areYouSure'),
            text: `${this.$t('vehicleRequests.approving')} "${row.metadata.car_request_model}" ${this.$t('vehicleRequests.forDate')} ${that.formatDate(row.metadata.car_request_needed_by_date)}`,
            type: 'success',
            showCancelButton: true,
            confirmButtonClass: 'btn btn-success btn-fill',
            cancelButtonClass: 'btn btn-fill',
            confirmButtonText: `${this.$t('vehicleRequests.yesApprove')}`,
            cancelButtonText: this.$t('general.cancel'),
            buttonsStyling: false
          }).then(function (res) {
            that.$store.requests.actions.modifyRequest('approve', row._id)
            .then( (error) => {
              if (error) return alerts.error(error);
              swal({
                title: that.$t('vehicleRequests.approved'),
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
              });
            })
            .catch( (err) => {
              console.error('problemi;', err);
            })


          }).catch( (err) => {});
      },
      reject(i, row) {
        let that = this;
        swal({
          title: this.$t('general.areYouSure'),
          text: `${this.$t('vehicleRequests.rejecting')} "${row.metadata.car_request_model}" ${this.$t('vehicleRequests.forDate')} ${that.formatDate(row.metadata.car_request_needed_by_date)}`,
          type: 'warning',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-danger btn-fill',
          cancelButtonClass: 'btn btn-fill',
          confirmButtonText: `${this.$t('vehicleRequests.yesReject')}`,
          cancelButtonText: this.$t('general.cancel'),
          buttonsStyling: false
        }).then(function (res) {
          that.$store.requests.actions.modifyRequest('reject', row._id)
            .then( (error) => {
              if (error) return alerts.error(error);
              swal({
                title: that.$t('vehicleRequests.rejected'),
                type: 'success',
                confirmButtonClass: 'btn btn-success btn-fill',
                buttonsStyling: false
              });

            })
            .catch( (err) => {
              console.error('problemi;', err);
            })
        }).catch( (err) => {});
      },
      sendNewActivity(caseId) {
        if (!this.newActivityText) return;
        let that = this;
        swal({
          title: this.$t('vehicleRequests.sendNewMessage'),
          text: `"${this.newActivityText}"`,
          type: 'info',
          showCancelButton: true,
          confirmButtonClass: 'btn btn-success btn-fill',
          cancelButtonClass: 'btn btn-fill',
          confirmButtonText: this.$t('vehicleRequests.yesSend'),
          cancelButtonText: this.$t('general.cancel'),
          buttonsStyling: false
        }).then(function (res) {
          that.newActivitySendInProgress = true;
          that.$store.requests.actions.sendActivity(that.newActivityText, caseId)
            .then( (error) => {
              that.newActivitySendInProgress = false;
              if (error) return alerts.error(error);
              that.newActivityText = '';
            })
            .catch( (err) => {
              console.error('problemi;', err);
              that.newActivitySendInProgress = false;
            })
        }).catch( (err) => {that.newActivitySendInProgress = false;});
      },
      rowClicked(row) {
        this.$refs.tableFleet.toggleRowExpansion(row);
        // tableFleet
      }
    }
  }

</script>
<style scoped>
  ::v-deep .card {
    background-color: transparent;
    box-shadow: unset;
  }
  ::v-deep .card-title {
    margin-top: unset;
  }
  ::v-deep .table-expandable tbody .el-table__row {
    background-color: white !important
  }
  ::v-deep .el-table table thead th div{
    text-overflow: clip !important;
    font-size: 0.8em;
    font-weight: bold;
    padding: 0px;
  }
  ::v-deep .table-expandable tbody .el-table__row td:first-child .cell {
    visibility: hidden !important;
  }
  ::v-deep .table-expandable tbody .el-table__row {
    cursor: zoom-in;
  }
  ::v-deep .table-expandable tbody .el-table__row.expanded {
    cursor: zoom-out;
  }
  ::v-deep .table-expandable tbody .el-table__row.expanded td {
    border-top: 2px solid black;
  }
  ::v-deep .table-expandable .el-table__expanded-cell {
    cursor: default;
    background-color: #eee !important;
    border-bottom: 2px solid black;
  }

  .refresh-btn {
    float: right;

  }
  .spinner-container-activity {
    margin-left: 5px;
  }
  .action-button {
    margin-left: 10px !important;
    margin-right: 10px !important;
  }
  .action-button i {
    font-size: 22px !important;
  }
  .action-buttons-col i {
	  font-size: 1.5em;
  }
  .status-icon {
    font-size: 30px !important;
  }
  .status-icon.info {
    color: #51bcda;
  }
  .status-icon.danger {
    color: #ef8157;
  }
  .status-icon.success {
    color: #6bd098;
  }

  .vehicle-request-tickets {
    padding-right: 55px;;
  }
  .speech-bubble {
    position: relative;
    background: #00aabb;
    border-radius: .4em;
    padding: 8px;
    margin-left: auto;

  }
  .msg-container {
    width: fit-content;
    margin-top:10px;
  }

  .from-portal .speech-bubble:after {
    content: '';
    position: absolute;
    top: 50%;
    width: 0;
    height: 0;
    border: 20px solid transparent;
    margin-top: -10px;
    right: 0;
    border-left-color: #B0E7ED;
    border-right: 0;
    border-bottom: 0;
    margin-right: -20px;
    margin-left: auto;
  }
  .from-flota {
    text-align:left;
  }
  .from-flota .speech-bubble {
    background-color: #FDD8A0;
  }

  .from-portal {
    text-align:right;
    margin-left: auto;
  }
  .from-portal .speech-bubble {
    background-color: #B0E7ED;
  }

  .activity-name {
    font-weight: bold;
  }
  .activity-text {
    font-size: 1.2em;
    font-style: italic;
  }
  .activity-text:before {
    content: '"';
  }
  .activity-text:after {
    content: '"';
  }
  .activity-datetime {
    color: gray;
  }
  .activity-input-container {
    margin-top: 20px;
  }
  .activity-input {
    width: 90%;
    background-color: white;
    text-align: center;
  }
  .send-activity-btn {
    height: 38px;
    margin-left: 10px !important;
    padding-top: 2px !important;
  }


</style>
